import { Controller } from "@hotwired/stimulus"

// «Scarica risultati JSON» di components/ProposteIncentivi.js: i dati della ricerca eseguita salvati nel browser come
// JSON.stringify(dati, null, 2), con il nome EROGO_proposte_incentivi_{data_conteggio}.json. I dati si rileggono dalla
// stessa ricerca (GET /api/admin/proposte-incentivi con i parametri eseguiti): la pagina non tiene in memoria tutte le
// schede. Solo dalla stessa origine della pagina; se la lettura non riesce, il toast d'errore.
//   <button data-controller="scarica-json" data-action="scarica-json#scarica"
//           data-scarica-json-url-value="/api/admin/proposte-incentivi?q=" data-scarica-json-nome-value="EROGO_….json">
export default class extends Controller {
  static values = { url: String, nome: String }

  async scarica(event) {
    event.preventDefault()
    try {
      const url = new URL(this.urlValue, window.location.href)
      if (url.origin !== window.location.origin) throw new Error(`Download da un'altra origine rifiutato: ${url.origin}`)
      const res = await fetch(url.href, { credentials: "same-origin", headers: { Accept: "application/json" } })
      if (!res.ok) throw new Error(`HTTP ${res.status}`)
      const dati = await res.json()
      const href = URL.createObjectURL(new Blob([JSON.stringify(dati, null, 2)], { type: "application/json" }))
      const a = document.createElement("a")
      a.href = href
      a.download = this.nomeValue
      document.body.appendChild(a)
      a.click()
      a.remove()
      URL.revokeObjectURL(href)
    } catch (e) {
      console.error("Download non riuscito", e)
      window.toast?.error?.("Si è verificato un errore. Riprova.")
    }
  }
}
